import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import ExamDetails from '../Modules/ExamDetails';

const AutomatedExamCard = observer(class AutomatedExamCard extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.messageInstructor = this.messageInstructor.bind(this);
  }

  messageInstructor(sid) {
    this.props.parent.setState({
      examSid: sid,
      messageSid: null
    });

    toggleDrawer(null, this.props.parent, 'MessageThread');
  }

  startButton(exam, examSession, examConfiguration, retake) {
    const { store, translation, schedulingClosed } = this.props;
    const { ScheduleStore } = store;
    const url = `/#/schedule-automated/exam/${exam.sid}/session/${examSession.sid}/configuration/${examConfiguration.sid}${schedulingClosed ? '/scheduleClosed' : ''}`


    if(!retake) {
      return (
        <a
          className="btn btn--success btn--icn-right "
          href={url}
          rel="opener"
        >
          {translation.start}
          <icons.iconCircleRight className="icon" />
        </a>
      )
    } else {
      return (
        <a
          className="btn btn--success btn--icn-right "
          href={url}
          rel="opener"
          onClick={e => {
            e.preventDefault();


            ScheduleStore.retakeSession(exam.sid, examSession.sid, url);
          }}
        >
          {translation.retake}
          <icons.iconCircleRight className="icon" />
        </a>
      )
    }
  }

  render() {
    const { exam, store, translation, schedulingClosed } = this.props;
    const { examSession } = exam;
    const { examConfiguration } = examSession;
    const { attemptsRemaining } = examConfiguration;
    const { SessionStore } = store;
    const { userTimezone } = SessionStore;

    let status;

    if(examSession) {
      status = examSession.status.toLowerCase();
    }

    const now = moment(SessionStore.currentTime);
    const examOpenDate = moment(examConfiguration.examOpenDate);
    const openDateFormatted = moment.utc(examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
    const examCloseDate = moment(examConfiguration.examCloseDate);
    const closeDateFormatted = moment.utc(examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')

    let examOpen = false;
    let examClosed = false;

    // Check if the exam is open
    if(moment.duration(examOpenDate.diff(now)).asMinutes() <= 0) {
      examOpen = true;
    }

    // Check if the exam is closed
    if(moment.duration(examCloseDate.diff(now)).asMinutes() <= 0) {
      examClosed = true;
    }

    return (
      <article className="panel">
        <header
          className={`panel__header${
            status === 'closed' || status === 'processing' ? ' panel__header--closed' : ' panel__header--ready'
          }`}
        >
          <h3 className="panel__title">
            <i className="panel__icn">
              <icons.iconLaptop />
            </i>

            {exam.title}
          </h3>
        </header>

        <div className="panel__body">
          {/* Status is closed or processing */}
          {(status === 'closed' || status === 'processing') &&
            <div className="cta">
              <strong className="cta__copy">
                {translation.completed.heading}
              </strong>

              {attemptsRemaining > 0 && !examClosed &&
                <span className="cta__subcopy">
                  {attemptsRemaining === 1 ?
                    translation.completed.attempt :
                    translation.completed.attempts.replace('%attemptCount%', attemptsRemaining)}
                </span>
              }

              {attemptsRemaining > 0 && !examClosed &&
                this.startButton(exam, examSession, examConfiguration, true)
              }

              {attemptsRemaining === 0 &&
                <span className="cta__subcopy">
                  {translation.completed.no_attempts}
                </span>
              }
            </div>
          }

          {/* Exam not yet open or unapproved */}
          {(!examOpen || !examConfiguration.approved) &&
            <div className="cta">
              <strong className="cta__copy">
                {translation.not_open.heading}
              </strong>

              <span className="cta__subcopy">
                {translation.not_open.body.replace('%openDate%', openDateFormatted)
                                          .replace('%closeDate%', closeDateFormatted)}
              </span>
            </div>
          }

          {/* Exam has closed */}
          {examClosed && status !== 'closed' && status !== 'processing' &&
            <div className="cta">
              <strong className="cta__copy">
                {translation.closed.heading}
              </strong>

              <span className="cta__subcopy">
                {translation.closed.body}
              </span>
            </div>
          }

          {/* Exam is open and can be started */}
          {examOpen && !examClosed && status !== 'closed' && status !== 'processing' &&
            <div className="cta">
              <strong className="cta__copy">
                {`${schedulingClosed ? translation.open.scheduling_closed.replace('%closeDate%', closeDateFormatted) : translation.open.heading.replace('%closeDate%', closeDateFormatted)}`}
              </strong>

              {(attemptsRemaining > 0 || status === 'scheduled') &&
                <span className="cta__subcopy">
                  {translation.open.body}
                </span>
              }

              {/*
                This shouldn’t happen, but we have seen a case on stage
                where an exam’s status was not closed yet but it’s
                attemptsRemaining somehow was set to 0.
              */}
              {attemptsRemaining === 0 && status !== 'scheduled' &&
                <span className="cta__subcopy">
                  {translation.completed.no_attempts}
                </span>
              }

              {(attemptsRemaining > 0 || status === 'scheduled') &&
                this.startButton(exam, examSession, examConfiguration)
              }
            </div>
          }

          {/* Exam details - show if exam is approved and session is not closed or processing */}
          {examConfiguration.approved && status !== 'closed' && status !== 'processing' &&
            <ExamDetails
              {...this.props}
              hideType
              hideDates
            />
          }
        </div>
      </article>
    )
  }
})

export default translate('AutomatedExamCard')(AutomatedExamCard);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/AutomatedExamCard.js